import { combineReducers } from 'redux';
import headerMenu from './header-menu';
import headerMenuLeft from './header-menu-left';
import userSession from './user-session';
import userOrganizations from './user-organization';
import calleds from './calleds';
import categories from './categories';
import slas from './slas';
import types from './types';
import organizations from './organizations';
import segments from './segments';
import groups from './groups';
import addresses from './addresses';
import organizationsettings from './organizationsettings';
import originrequests from './originrequests';
import calledclassifications from './calledclassifications';
import users from './users';
import techinicalteams from './techinicalteams';
import techinicalteamusers from './techinicalteamusers';
import techinicalteamorganizationcategories from './techinicalteamorganizationcategories';
import techinicalteamorganizations from './techinicalteamorganizations';
import categoryorganizations from './categoryorganizations';
import roles from './roles';
import permissions from './permissions';
import organizationcalendars from './organizationcalendars';
import organizationfields from './organizationfields';
import calledstatuses from './calledstatuses';
import assignedcalleds from './assignedcalleds';
import configs from './configs';
import statuses from './statuses';
import calledorganizationmaterials from './calledorganizationmaterials';
import calledflows from './calledflows';
import organization from './organization';

import calledflowstatuses from './calledflowstatuses';

import distributionstrategies from './distributionstrategies';

import organizationcategories from './organizationcategories';

import organizationslas from './organizationslas';

import organizationslacalleds from './organizationslacalleds';

import scheduleworkhours from './scheduleworkhours';

import slacounttypes from './slacounttypes';

import workhours from './workhours';
import calledvideocalls from './calledvideocalls';
import holidays from './holidays';
import materials from './materials';

import organizationdepartaments from './organizationdepartaments';

import organizationmaterials from './organizationmaterials';

import organizationpatrimonies from './organizationpatrimonies';

import patrimonygroups from './patrimonygroups';

import patrimonymaterials from './patrimonymaterials';

import patrimonysubgroups from './patrimonysubgroups';

import organizationaccountemails from './organizationaccountemails';

import relationshipcalled from './relationshipcalled';

import organizationchecklists from './organizationchecklists'
import knowledgebases from './knowledgebases';

import calledorganizationchecklists from './calledorganizationchecklists'

import calledorganizationfields from './calledorganizationfields'

import additionalcalledcosts from './additionalcalledcosts'

import reasons from './reasons'

import activitys from './activitys'
import npssearchs from './npssearchs'
import timeentries from './timeentries'
import { googleReducer } from "./reducerGoogle"
import multihirer from './multihirer';
import defaultactions from './defaultactions';
import priorities from './priorities'
import calledclosingstatuses from './calledclosingstatuses'
import calledlistdatas from './calledlistdatas'
import calledreportconfigs from './calledreportconfigs'
import organizationcategoryportal from './organizationcategoryportal'
import additionalcalledcostitems from './additionalcalledcostitems'
import additionalcalledcostitemtypes from './additionalcalledcostitemtypes'
import additionalcalledcostitemreasons from './additionalcalledcostitemreasons'
import organizationfieldreportblocks from './organizationfieldreportblocks'
import shippingservicesettings from './shippingservicesettings'
import richtextarea from './richtextarea'
import units from './units'
import whitelabelconfigs from './whitelabelconfigs'

export default combineReducers({
    reasons,
    activitys,
    npssearchs,
    timeentries,
    addresses,
    groups,
    segments,
    organizations,
    types,
    headerMenu,
    userSession,
    calleds,
    categories,
    slas,  
    users,
    calledclassifications,
    originrequests,
    organizationsettings,
    techinicalteams,
    techinicalteamusers,
    techinicalteamorganizations,
    techinicalteamorganizationcategories,   
    categoryorganizations, 
    roles,
    permissions,
    statuses,
    assignedcalleds,
    organizationcalendars,
    organizationfields,
    configs,
    defaultactions,
    workhours,
    slacounttypes,
    scheduleworkhours,
    organizationslacalleds,
    organizationslas,
    organizationcategories,
    distributionstrategies,
    calledflowstatuses,
    calledflows,    
    calledvideocalls,
    holidays,
    calledstatuses,
    patrimonysubgroups,
    patrimonymaterials,
    patrimonygroups,
    organizationpatrimonies,
    organizationmaterials,
    organizationdepartaments,
    materials,
    calledorganizationmaterials,
    organization,
    organizationaccountemails,
    relationshipcalled,
    organizationchecklists,
    knowledgebases,
    calledorganizationchecklists,
    calledorganizationfields,
    additionalcalledcosts,
    organizationcategoryportal,
    googleReducer,
    multihirer,
    priorities,
    userOrganizations,
    calledclosingstatuses,
    calledlistdatas,
    calledreportconfigs,
    additionalcalledcostitems,
    additionalcalledcostitemtypes,
    additionalcalledcostitemreasons,
    organizationfieldreportblocks,
    shippingservicesettings,
    richtextarea,
    units,
    whitelabelconfigs
});
